import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { useChatContext } from '../ChatContext';
import { IconButton } from './IconButton';

export const CollapseButton = () => {
  const { collapse, isCollapsed } = useChatContext();

  if (!collapse) {
    return null;
  }

  return (
    <IconButton onClick={() => collapse(!isCollapsed)}>
      {isCollapsed ? (
        <PlusIcon width={14} height={14} color="secondaryText" />
      ) : (
        <MinusIcon width={12} height={12} color="secondaryText" />
      )}
    </IconButton>
  );
};
